// import React from 'react' // 暂时未使用
import ReactDOM from 'react-dom/client'
import App from './App'
import { AppStateProvider } from './contexts/AppStateContext'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import '@unocss/reset/normalize.css'
import 'react-vant/lib/index.css'
import 'virtual:uno.css'
import './style.css'

ReactDOM.createRoot(document.getElementById('app')!).render(
  <I18nextProvider i18n={i18n}>
    <AppStateProvider>
      <App />
    </AppStateProvider>
  </I18nextProvider>
)